<template>
  <form @submit.prevent="assign" id="assign_form">
    <div class="row">
      <div class="col-md-12 mb-3">
        <label>Select Writer</label>
        <vue-select
          :options="writers"
          label="name"
          placeholder="Select Writer"
          v-model="selected_writer"
        />
        <input type="hidden" name="user_id" class="form-control" />
      </div>
      <div class="col-md-6 mb-3">
        <label>Writer Payment</label>
        <div class="input-group mb-3">
          <span class="input-group-text">KES</span>
          <input
            type="number"
            class="form-control"
            placeholder="Amount"
            v-model="payment"
            name="payment"
          />
          <span class="input-group-text">({{ payment_per_word }} per word)</span>
        </div>
      </div>
      <div class="col-md-6 mb-3">
        <label>Allowed Time In Hours</label>
        <input
            type="number"
            class="form-control"
            placeholder="Allowed Time"
            v-model="hours"
            name="hours"
          />
      </div>
    </div>
    <div>
      <button class="btn btn-primary"><i class="fal fa-save"></i>Assign</button>
    </div>
  </form>
</template>

<script>
export default {
  data() {
    return {
      selected_writer: null,
      payment: null,
      hours: 24
    };
  },

  props: ["writers", "words"],

  methods: {
    assign() {
      let data = {
        form_id: "assign_form",
        user_id: this.selected_writer ? this.selected_writer.id : null,
        payment: this.payment,
        hours: this.hours,
        action: "assign",
      };

      this.$axios
        .put(`/api/v1/admin/orders/${this.$route.params.id}`, data)
        .then(() => {
          this.$toast.success('Order has been sent to the writer')
          this.$emit('success');
        });
    },
  },

  computed: {
    payment_per_word() {
      return parseFloat(this.payment / this.words).toFixed(2)
    }
  }
};
</script>
